/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CspUserRoles } from './cspUserRoles';
import { CspUserProfile } from './cspUserProfile';


export interface CspUserDetails { 
    /**
     * User ID
     */
    userId?: string;
    /**
     * Username
     */
    username?: string;
    /**
     * First name
     */
    firstName?: string;
    /**
     * Last name
     */
    lastName?: string;
    /**
     * Email address
     */
    email?: string;
    /**
     * Account identifier
     */
    acct?: string;
    /**
     * Domain
     */
    domain?: string;
    /**
     * Whether user is accessible
     */
    accessible?: boolean;
    userProfile?: CspUserProfile;
    roles?: CspUserRoles;
}

